import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

const categoryNameMap: Record<string, string> = {
  'guobiao-majiang': '国标麻将',
  'sichuan-majiang': '四川麻将',
  'guangdong-majiang': '广东麻将',
  'majiang-jiqiao': '麻将技巧',
  'majiang-wenhua': '麻将文化',
  'xinshou-rumen': '新手入门',
};

const articleTitleMap: Record<string, string> = {
  'guobiao-majiang-wanzheng-guize': '国标麻将完整规则详解',
  'sichuan-majiang-xuezhan-dadi': '四川麻将血战到底',
  'guangdong-majiang-ruhe-kuaisu-shangshou': '广东麻将快速上手',
  'majiang-chuxuezhe-bibei-jiqiao': '麻将初学者必备技巧',
  'majiang-lishi-wenhua-qiyuan': '麻将的历史起源与文化传承',
  'majiang-jibenshuyu-quanjie': '麻将基本术语全解',
  'guobiao-majiang-gaofen-fanzhong': '国标麻将高分番种攻略',
  'shouji-majiang-tuijian': '2026手机麻将App推荐',
};

export default function Breadcrumb() {
  const { t } = useTranslation();
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: t('breadcrumb.home'), to: '/' }];

  if (pathParts[0] === 'category' && pathParts[1]) {
    items.push({
      label: categoryNameMap[pathParts[1]] || pathParts[1],
    });
  } else if (pathParts[0] === 'article' && pathParts[1]) {
    items.push({
      label: articleTitleMap[pathParts[1]] || pathParts[1],
    });
  } else if (pathParts[0] === 'about') {
    items.push({ label: t('about.title') });
  } else if (pathParts[0] && pathParts[0] !== '/') {
    items.push({
      label: pathParts[0].replace(/-/g, ' '),
    });
  }

  if (items.length <= 1) return null;

  return (
    <nav aria-label="Breadcrumb" className="w-full px-4 md:px-6 pt-20 pb-0">
      <ol className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            )}
            {item.to && index < items.length - 1 ? (
              <Link
                to={item.to}
                className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}